import { STRAPI_URL } from '../env';

/**
 * Resolve the Strapi base URL from runtime/build env.
 * Kept in a dedicated module to avoid circular imports between
 * graphql client utilities and higher-level Strapi content helpers.
 */
export const getStrapiBaseUrl = (): string => {
    // In browser, use the current hostname (works for local network access)
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        // If accessing via IP address or network hostname, use that for backend
        // Otherwise fall back to environment variable or localhost
        // if (hostname !== "localhost" && hostname !== "127.0.0.1") {
        //   return `http://${hostname}:1337`;
        // }
        void hostname;
    }

    // Access environment variable (replaced by Vite define at build time)
    if (typeof process !== 'undefined' && process.env?.VITE_APP_STRAPI_URL) {
        return process.env.VITE_APP_STRAPI_URL;
    }

    return STRAPI_URL;
};
